import "./styles.css";

const InfoImg = ({ imgSrc }) => {

	return (
		<div className="imgCont">
			<img src={imgSrc}/>
		</div>
	);
};

export default InfoImg;
